import Values from './Values';

export default Values;


// WEBPACK FOOTER //
// ./src/scenes/Attributes/AttributeDetail/components/Values/index.tsx